import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";
import { darkTheme } from "src/Theme/darkTheme";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IoProvider } from "socket.io-react-hook";
import { AppModeProvider } from "src/Common/context/AppModeContext";

const theme = createTheme(darkTheme);
const queryClient = new QueryClient();

// Check if auth is disabled for local development
export const AUTH_DISABLED =
  import.meta.env.VITE_AUTH_DISABLED === "true" ||
  import.meta.env.DEV; // Always disable in Vite dev mode

export const Providers = ({ children }: { children: React.ReactNode }) => (
  <IoProvider>
    <ThemeProvider theme={theme}>
      <EmotionThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <LocalizationProvider dateAdapter={AdapterLuxon}>
            <AppModeProvider>
              <ToastContainer />
              {children}
              <ReactQueryDevtools initialIsOpen={false} />
            </AppModeProvider>
          </LocalizationProvider>
        </QueryClientProvider>
      </EmotionThemeProvider>
    </ThemeProvider>
  </IoProvider>
);
